import { jsx as r } from "react/jsx-runtime";
import { forwardRef as s } from "react";
import "styled-components";
import { useThemeInMode as a } from "../../../../../../context/theme/hooks.js";
import u from "../../../../../../styles/shadows/useShadow.js";
import f from "../../../../../layout/Stack/Stack.js";
import p from "../../../../../layout/Box/Box.js";
import "../../../../../../index-CZ8zjHGv.js";
import "../../../../../layout/Center/Center.js";
import "../../../../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import "../../../../../layout/Columns/ColumnsContext.js";
const C = s(
  (o, t) => {
    const { children: e, position: m } = o, i = a(), n = u("large"), d = l(m);
    return /* @__PURE__ */ r(
      p,
      {
        zIndex: 2,
        backgroundColor: i.foreground,
        boxShadow: n,
        overflow: "hidden",
        ...d,
        children: /* @__PURE__ */ r(f, { ref: t, children: e })
      }
    );
  }
), l = (o) => o === "bottomLeft" ? {
  borderRadius: "xsmall",
  borderTopRightRadius: "none"
} : o === "bottomRight" ? {
  borderRadius: "xsmall",
  borderTopLeftRadius: "none"
} : {
  borderRadius: "xsmall"
};
export {
  C as ContextMenu,
  C as default
};
